import React, { useState } from "react";

const Alerts = () => {
  const [selectedAlert, setSelectedAlert] = useState(null);

  const alerts = [
    {
      message: "Aerator #3 stopped",
      type: "critical",
      tag: "Equipment Failure",
      image: "/aerator.jpg",
    },
    {
      message: "No staff detected in Pond B",
      type: "warning",
      tag: "Workforce Monitoring",
    },
    {
      message: "Unauthorized vehicle entry",
      type: "critical",
      tag: "Security Breach",
      image: "/vehicle.jpg",
    },
    {
      message: "Night movement detected",
      type: "warning",
      tag: "AI Motion Detection",
    },
    {
      message: "Routine patrol completed",
      type: "info",
      tag: "System Log",
    },
  ];

  const getStyle = (type) => {
    switch (type) {
      case "critical":
        return "bg-red-100 text-red-600";
      case "warning":
        return "bg-yellow-100 text-yellow-700";
      case "info":
        return "bg-green-100 text-green-600";
      default:
        return "bg-gray-100";
    }
  };

  return (
    <div className="bg-white p-6 rounded-xl shadow space-y-4">

      {/* HEADER */}
      <div className="flex items-center">
        <h2 className="text-xl font-semibold text-red-600">
          🚨 Alerts & AI Logs
        </h2>

        <span className="ml-auto bg-gray-100 px-3 py-1 text-sm rounded-full">
          Real-time Monitoring
        </span>
      </div>

      {/* ALERT LIST */}
      <ul className="space-y-3">
        {alerts.map((alert, index) => (
          <li
            key={index}
            onClick={() => alert.image && setSelectedAlert(alert)}
            className={`flex items-center justify-between p-3 border rounded-lg ${
              alert.image ? "cursor-pointer hover:shadow-md" : ""
            }`}
          >
            <div className="flex items-center gap-3">

              {/* SHOW IMAGE ONLY FOR CRITICAL */}
              {alert.type === "critical" && alert.image && (
                <img
                  src={alert.image}
                  alt="alert"
                  className="w-12 h-12 object-cover rounded"
                />
              )}

              <div>
                <p className="font-medium">{alert.message}</p>
                <p className="text-xs text-gray-500">{alert.tag}</p>
              </div>
            </div>

            <span
              className={`text-xs px-2 py-1 rounded-full ${getStyle(
                alert.type
              )}`}
            >
              {alert.type.toUpperCase()}
            </span>
          </li>
        ))}
      </ul>

      {/* PREVIEW MODAL */}
      {selectedAlert && (
        <div className="fixed inset-0 bg-black/40 flex items-center justify-center z-50">
          <div className="bg-white rounded-xl w-[90%] max-w-[700px] p-5 space-y-4">

            <h3 className="text-lg font-semibold">
              {selectedAlert.message}
            </h3>

            <img
              src={selectedAlert.image}
              alt="preview"
              className="w-full max-h-[70vh] object-contain rounded bg-black"
            />

            <p className="text-sm text-gray-500">
              {selectedAlert.tag}
            </p>

            <button
              onClick={() => setSelectedAlert(null)}
              className="w-full bg-gray-800 text-white py-2 rounded"
            >
              Close
            </button>
          </div>
        </div>
      )}

    </div>
  );
};

export default Alerts;